import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { TaskStateEditabilityType } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { ITaskStateListItem } from "./taskStateListItem";

export interface ITaskStateEditItem extends IEditItem {
    code: string;
    comment: string;
    color: string;
    sortOrder: number;
    editabilityType: TaskStateEditabilityType;
    activeState: number;
    modifyUser: IModifyUser;
}

export class TaskStateEditItem extends EditItem implements ITaskStateEditItem {
    code: string;
    comment: string;
    color: string;
    sortOrder: number;
    editabilityType: TaskStateEditabilityType;
    activeState: number;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: ITaskStateEditItem);
    constructor(obj?: ITaskStateListItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.color = obj && obj.color || "";
        this.sortOrder = obj && obj.sortOrder || 0;
        this.editabilityType = obj && obj.editabilityType || TaskStateEditabilityType.NoLimitation;
        this.activeState = obj && obj.activeState || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}

export type TTaskStateEditItemNewSave = {
    id: string;
    code: string;
    comment: string;
    color: string;
    sortOrder: number;
    editabilityType: TaskStateEditabilityType;
    activeState: number;
}